import Icon from 'veui/components/Icon'
import { IconLayer } from 'dls-icons-vue'

Icon.register('layer', IconLayer)
